import React from 'react';
import { View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { MODEL_TOTAL } from '@/constants/modelInventory.generated';
import { GhostCta, Section, useLanding } from './LandingKit';
import { fluid, isWeb } from './landingTokens';

const CAPABILITIES = [
  { icon: 'lightbulb', number: '01', title: 'Start with an idea.', copy: 'A question, a rough draft, a project you’ve been putting off. Tell Gab AI what you have in mind and where you want to go.' },
  { icon: 'laptop', number: '02', title: 'Give it room to work.', copy: `With its own computer and ${MODEL_TOTAL} AI models to call on, Work can research, write, build, and create. You stay in control of the direction.` },
  { icon: 'file-export', number: '03', title: 'Make it yours.', copy: 'Open the website, review the slides, or fine-tune the spreadsheet. Get real files to edit and share, then ask for changes until they’re right.' },
];

function LandingWorkMode() {
  const { c, band, width } = useLanding();
  const compact = width < 850;
  const size = fluid(width, 32, 52);

  return (
    <Section label="How Gab AI Work works" background={band.bg} contentStyle={{ paddingVertical: fluid(width, 56, 96) }}>
      <View style={{ flexDirection: compact ? 'column' : 'row', alignItems: compact ? 'flex-start' : 'flex-end', justifyContent: 'space-between', gap: 24, marginBottom: fluid(width, 30, 44) }}>
        <View style={{ maxWidth: 620 }}>
          <Text weight="semibold" style={{ color: c.accent, fontSize: 14, marginBottom: 16 }}>Meet Work mode</Text>
          <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.1), letterSpacing: -size * 0.045, ...(isWeb ? { whiteSpace: 'pre-line' } : {}) }}>{'A little direction.\nA lot off your plate.'}</Text>
        </View>
        <View style={{ maxWidth: 310, gap: 12 }}>
          <Text style={{ color: c.inkSoft, fontSize: 16, lineHeight: 25 }}>An AI agent that takes your project from “what if” to ready for your review.</Text>
          <GhostCta label="Explore plans with Work" href="/pricing" />
        </View>
      </View>
      <View style={{ flexDirection: compact ? 'column' : 'row', gap: 18 }}>
        {CAPABILITIES.map(item => (
          <View key={item.number} style={{ flex: compact ? undefined : 1, minWidth: 0, backgroundColor: c.cardSolid, borderRadius: 24, padding: fluid(width, 26, 32), borderWidth: 1, borderColor: c.rule }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: compact ? 24 : 40 }}>
              <Icon name={item.icon} size={23} color={c.accent} />
              <Text style={{ color: c.muted, fontSize: 12 }}>{item.number}</Text>
            </View>
            <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 23, lineHeight: 28, letterSpacing: -0.7 }}>{item.title}</Text>
            <Text style={{ color: c.inkSoft, fontSize: 15, lineHeight: 25, marginTop: 14 }}>{item.copy}</Text>
          </View>
        ))}
      </View>
    </Section>
  );
}

export default React.memo(LandingWorkMode);
